// =================

import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  ChangeEvent,
  DragEvent,
  CSSProperties,
  ReactNode,
} from 'react';
import axios, { CancelTokenSource, AxiosRequestConfig, AxiosProgressEvent } from 'axios';
// import Api from '@/api';
// import Button from '../Button';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';
// import Modal from '@/components/structure/Modal';
// import CropImage from './CropImage';
// import AppLink from '../AppLink';
// import Modal from '../modal';
// import Button from '../FormItem/Button';
import Link from 'next/link';
import Button from '../Button';
import Modal from '@/components/structure/Modal';
import { useTranslations } from 'next-intl';
import { UploadType } from '@/commonTypes';
import CropImage from './CropImage';
import Api from '@/api';
import { useServerMessage } from '@/functions/useServerMessage';

interface UploadedFile {
  href?: string;
  name?: string;
  [key: string]: any;
}
const typeMap: Record<string, string> = {
  image: 'image/*',
  video: 'video/*',
  music: 'audio/*',
  pdf: '.pdf',
};
interface UploaderProps {
  modalKey?: string;
  id?: string;
  onUploadComplete: (data: any) => void;
  headTitle?: string;
  children?: React.ReactNode;
  uploadedFile?: UploadedFile | null;
  showImg?: boolean;
  uploadType?: UploadType;
  buttonText?: string;
  api?: (formData: FormData, config: AxiosRequestConfig) => Promise<any>;
  showError?: boolean;
  error?: string;
  onProgressChange?: (progress: number) => void;
  callBackFile?: (progress: any) => void;
  style?: CSSProperties;
  enableDragAndDrop?: boolean;
  buttonContainerClassName?: string;
  uploadButton?: ReactNode;
  container?: string;
  isPreviewImage?: File | null;
  setIsPreviewImage?: React.Dispatch<React.SetStateAction<File | null>>;
  cropMode?: boolean;
  cropContainer?: string;
  showToggle?: boolean;
  suitableAspect?: number;
  vertical?: boolean;
  UploadButtonStyle?: string;
}

const Uploader: React.FC<UploaderProps> = ({
  modalKey = '',
  id = 'uploader',
  onUploadComplete,
  headTitle,
  children,
  uploadedFile = null,
  showImg = true,
  uploadType = 'image',
  buttonText = 'آپلود',
  api = Api.uploadFile,
  showError = false,
  error = 'این فیلد ضروری است.',
  onProgressChange = () => {},
  callBackFile = (e) => {},
  style = {},
  enableDragAndDrop = false,
  buttonContainerClassName = '',
  uploadButton = '',
  container = '',
  isPreviewImage = null,
  setIsPreviewImage,
  cropMode = false,
  cropContainer = '',
  showToggle = false,
  suitableAspect = 16 / 9,
  vertical = true,
  UploadButtonStyle = '',
}) => {
  const [showCrop, setShowCrop] = useState(false);
  const [previewImage, setPreviewImage] = useState<File | null>(isPreviewImage);
  const cancelTokenSource = useRef<CancelTokenSource | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const {
    setServerMessage,
    cancelUploadMap,
    cancelUploadFor,
    resetCancelUploadFor,
    setIswaiting,
    isWaiting,
    closeModal,
  } = useLayoutContext();
  const t = useTranslations('common');
  const { translateError } = useServerMessage();

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [dragOver, setDragOver] = useState(false);

  console.log('modalkey', modalKey);

  useEffect(() => {
    if (isPreviewImage) {
      setPreviewImage(isPreviewImage);
      setShowCrop(true);
    }
  }, [isPreviewImage]);
  const handleShowModal = () => {
    setShowCrop(false);
    setIsPreviewImage && setIsPreviewImage(null);
    setPreviewImage(null);
  };

  useEffect(() => {
    const cancelValue = cancelUploadMap[modalKey];
    if (!cancelValue) return;

    if (cancelValue === 'closeModal') {
      if (cancelTokenSource.current) {
        cancelTokenSource.current.cancel('Upload cancelled because modal closed');
      }
      cancelUploadFor(modalKey, 'done');
    }
  }, [cancelUploadMap[modalKey]]);

  const handleFileUpload = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    callBackFile && callBackFile(event);
    if (!file) return;
    console.log('file==', file);
    if (cropMode) {
      setShowCrop(true);
      setPreviewImage(file);
    } else {
      fileUploadFunction(file);
      event.target.value = '';
    }
  };

  const fileUploadFunction = (file: any) => {
    cancelTokenSource.current = axios.CancelToken.source();
    let formData = new FormData();
    // if (default==true) {

    formData.append('file', file);
    // }else{

    //   formData.append('file', file, file.name );
    // }

    setLoading(true);
    setIsLoading(true);
    setProgress(0);
    setIswaiting(true);

    const config: AxiosRequestConfig = {
      onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        if (progressEvent.total) {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setProgress(percentCompleted);
          onProgressChange && onProgressChange(percentCompleted);
        }
      },
      cancelToken: cancelTokenSource.current?.token,
    };

    api(formData, config)
      .then((res: { data?: string }) => {
        onUploadComplete && onUploadComplete(res?.data);
        setIswaiting(false);
      })
      .catch(
        (err: {
          message?: string;
          response?: { data?: { message?: string; detail?: string } };
        }) => {
          if (axios.isCancel(err)) {
            console.log(`Upload cancelled (${modalKey}):`, err.message);
            setServerMessage && setServerMessage({ text: t('uploadCanceled') });

            if (cancelUploadMap[modalKey] === 'closeModal') {
              cancelUploadFor(modalKey, 'done');
            }
          } else {
            console.error('Upload failed:', err);
            setServerMessage &&
              setServerMessage({
                text: translateError(err),
              });
          }
        },
      )
      .finally(() => {
        setIsLoading(false);
        setLoading(false);
        setIswaiting(false);
        setProgress(0);
        if (fileInputRef.current) fileInputRef.current.value = '';
      });
  };
  const handleCancel = () => {
    if (cancelTokenSource.current) {
      cancelTokenSource.current.cancel(`Manual cancel (${modalKey})`);
      setIsLoading(false);
      setLoading(false);
      setIswaiting(false);
      setProgress(0);
      setServerMessage && setServerMessage({ text: t('uploadCanceled') });
    }
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const fileEvent = {
        target: { files: e.dataTransfer.files },
      } as unknown as ChangeEvent<HTMLInputElement>;
      handleFileChange(fileEvent);
      e.dataTransfer.clearData();
    }
  };

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };
  const UploadButton = (
    <div
      className={`${styles.buttonContainer} ${buttonContainerClassName}`}
      onClick={handleFileUpload}
      style={{ width: 'auto' }}
    >
      {uploadButton}
    </div>
  );
  // const acceptedTypes =
  //   uploadType === 'image'
  //     ? 'image/*'
  //     : uploadType === 'video'
  //       ? 'video/*'
  //       : uploadType === 'music'
  //         ? 'audio/*'
  //         : uploadType === 'pdf'
  //           ? '.pdf'
  //           : '*/*';

  const acceptedTypes =
    uploadType
      ?.split(',')
      .map((type) => typeMap[type.trim()])
      .filter(Boolean)
      .join(',') || '*/*';

  return (
    <>
      <div
        className={`${styles.container} ${container} ${!vertical && 'horizontalFormItem'}`}
        style={style}
      >
        {headTitle && (
          <p className={`${styles.description_teacher_button} formTitle`}>{headTitle || ' '}</p>
        )}

        {enableDragAndDrop ? (
          <div
            className={`${styles.dropZone} ${dragOver ? styles.dragOver : ''}  ${showError && 'inputError'}`}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
          >
            {UploadButton}
          </div>
        ) : (
          <div className={`${UploadButtonStyle}`}> {UploadButton}</div>
        )}

        {children}

        {/* {showImg &&
          (isLoading ? (
            <div className={`${styles.progress}`}>
              <p>{`${"در حال بارگزاری"} ${progress}%`}</p>
              <Button onClick={handleCancel} className={`secondButton ${styles.cancelButton}`}>
               انصراف
              </Button>
            </div>
          ) : (
            uploadedFile && (
              <div className={styles.uploadedFileStyle}>
                <p>{"لینک فایل"}</p>
                <Link target="_blank" href={uploadedFile?.href || ''}>
                  {uploadedFile?.name}
                </Link>
              </div>
            )
          ))} */}

        <input
          key={progress + id}
          name="upload"
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept={acceptedTypes}
          onChange={handleFileChange}
        />

        {showError && error && <p className="inputErrorText">{error}</p>}
      </div>
      {showImg &&
        (isLoading ? (
          <div className={`${styles.progress}`}>
            <p>{`${t('uploading')} ${progress}%`}</p>
            <Button onClick={handleCancel} className={`secondButton ${styles.cancelButton}`}>
              {t('cancel')}
            </Button>
          </div>
        ) : (
          uploadedFile && (
            <div className={styles.uploadedFileStyle}>
              <p>{'لینک فایل'}</p>
              <Link target="_blank" href={uploadedFile?.href || ''}>
                {uploadedFile?.name}
              </Link>
            </div>
          )
        ))}
      {cropMode && showCrop && (
        <Modal
          extraContentStyle={`${styles.containerStyle} ${cropContainer}`}
          handleShowModal={() => {
            closeModal(() => {
              handleShowModal();
            }, !isWaiting);
          }}
          title={'ویرایش تصویر'}
          // modalKey={modalKey}
        >
          <CropImage
            previewImage={previewImage}
            setSelectedFile={(x: any) => {
              console.log('croppedFile', x);
              const fileName = 'cropped.png';
              const croppedFile = new File([x], fileName, {
                type: 'image/png',
                lastModified: Date.now(),
              });

              fileUploadFunction(croppedFile);
            }}
            className={`${styles.modalContent} `}
            handleShowModal={() => {
              closeModal(() => {
                handleShowModal();
              }, !isWaiting);
            }}
            showToggle={showToggle}
            suitableAspect={suitableAspect}
          />
        </Modal>
      )}
    </>
  );
};

export default Uploader;
